<template>
  <div>
    <div class="one section">
      <div class="container" style="padding-top: 3em; padding-bottom: 3em;">
        <div class="columns">
          <div class="column" style="text-align: center;">
            <article style="font-weight: bold">
              <h1 class="subtitle is-2 hide-mobile">
                Automate condo association insurance certificate requests
              </h1>
              <h1 class="subtitle is-3 hide-desktop">
                Automate condo association insurance certificate requests
              </h1>
              <p>
                We provide a simple, cost effective solution to remove the burden of condo association evidence of insurance requests from
                banks and property owners.
              </p>
              </br>
              <p>
                Contact us now for a free, no obligation trial and assistance getting started.
              </p>
              </br>
              <a class="button is-success is-large" @click="showContactForm = true">Contact Us</a>
            </article>
          </div>
          <div class="column hide-mobile">
            <figure class="image" style="margin-left: 10%; min-height: 330px;">
              <img id="cta-image" src="/static/img/LandingPageCertificateForm.jpg">
            </figure>
          </div>
        </div>
      </div>
    </div>

    <div class="section two">
      <div class="container" style="padding-top: 3em;">
        <div class="columns">
          <div class="column hide-mobile">
            <figure class="image center-image" style="min-height: 358px;">
              <img id="cta-image" src="/static/img/LandingPageManageAssociations.jpg">
            </figure>
          </div>
          <div class="column is-two-thirds">
            <h2 class="subtitle is-5">
              Manage your associations, policies and coverage details
            </h2>
            <p>
              Once you set up an association, you will get a direct link for requesters to access the applicable evidence of insurance
              certificate. Decide on privacy controls and distribute the link to anyone who needs access to the certificate to streamline the process and
              provide better service to your associations.
            </p>
            </br>
            <p>
              For more information, read our
              <router-link to="/documentation" class="has-text-info">Getting Started</router-link> page.
            </p>
            </br>
            <h2 class="subtitle is-5">
              Simple monthly pricing
            </h2>
            <p>
              Unlimited associations and requests for a flat monthly price.
              <a class="has-text-info" @click.prevent="showContactForm = true">Contact us</a> for a special introductory rate.
            </p>
            </br>
            <h2 class="subtitle is-5">
              Try it out
            </h2>
            <p>
              Try a demo request now and generate a sample EOI certificate.
            </p>

            </br>
            <router-link to="/certificates/arrowig/ABC123" class="button is-link">Demo</router-link>

          </div>
        </div>
      </div>
    </div>

    <div class="section three">
      <div class="container" style="">
        <div class="columns">
          <div class="column is-one-third">
            <div class="box" style="min-height: 150px;">
              <h2 class="subtitle is-5">
                Do you need an insurance certificate?
              </h2>
              <router-link to="/certificates" class="button is-link is-outlined">Search By Association</router-link>
            </div>
          </div>
          <div class="column is-one-third">
            <div class="box" style="min-height: 150px;">
              <h2 class="subtitle is-5">
                Broker Login
              </h2>
              <router-link to="/associations" class="button is-link is-outlined">Login</router-link>
            </div>
          </div>
          <div class="column is-one-third">
            <div class="box" style="min-height: 150px;">
              <h2 class="subtitle is-5">
                Certificate of Property Insurance Form
              </h2>
              <router-link to="/fillable-certificate-of-property-insurance-form" class="button is-link is-outlined">Online Fillable Form</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Footer></Footer>

    <div class="modal" :class="{'is-active': showContactForm}">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Contact Us</p>
          <button @click="showContactForm = false" class="delete"></button>
        </header>
        <div v-if="!contactSuccess">
          <section class="modal-card-body">
            <div class="content">
              <div class="field">
                <label class="label">Email Address</label>
                <div class="control">
                  <input class="input" type="text" v-model="contact.email" placeholder="Enter your email address">
                </div>
              </div>
              <!--               <div class="field">
                <label class="label">Name</label>
                <div class="control">
                  <input class="input" type="text" v-model="contact.name" placeholder="Enter your name">
                </div>
              </div>
              <div class="field">
                <label class="label">Phone Number</label>
                <div class="control">
                  <input class="input" type="text" v-model="contact.phone" placeholder="Enter your phone number">
                </div>
              </div> -->
              <div class="field">
                <label class="label">Message</label>
                <div class="control">
                  <textarea class="textarea" v-model="contact.message" placeholder="Enter your message, we'll respond as quickly as possible"></textarea>
                </div>
              </div>
            </div>
          </section>
          <footer class="modal-card-foot">
            <a class="button is-success" @click="sendContactMessage(contact)">Send</a>
            <a @click="showContactForm = false" class="button">Cancel</a>
          </footer>
        </div>
        <div v-if="contactSuccess">
          <section class="modal-card-body">
            Thank you for contacting us. We will return your message as soon as possible.
            </br>
            </br>
          </section>
          <footer class="modal-card-foot">
            <a @click="showContactForm = false" class="button">Close</a>
          </footer>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import Footer from '@/Footer'
  import tenant from '@/tenant'
  import axios from 'axios'
  export default {
    name: 'Home',
    data: function () {
      return {
        tenantName: '',
        showContactForm: false,
        contactSuccess: false,
        contact: {
          name: '',
          email: '',
          phone: '',
          message: ''
        }
      }
    },
    created: function () {
      tenant.initialize().then(() => {
        this.tenantName = tenant.name
      })
    },
    methods: {
      sendContactMessage(contact) {
        let message = `New Contact Us request` +
          `\nEmail: ` + contact.email +
          `\n` + contact.message
        axios.post(process.env.API_BASE_URL + '/api/contact-us', message)
          .then(() => {
            this.contactSuccess = true
          }).catch((error) => {
            this.contactSuccess = true
            console.log(error)
          })
      }
    },
    components: {
      Footer
    }
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1,
  h2 {
    font-weight: bold;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #42b983;
  }

  .center-image {
    margin-left: auto;
    margin-right: auto;
    display: block;
  }

  .image {
    background: white;
    width: 300px;
    border-radius: 5px;
    box-shadow: 3px 3px 3px #535252;
  }

  #cta-image {
    border: 1px solid #535252;
    border-radius: 5px;
    max-width: 300px;
    padding: 10px;
    opacity: 0.75;
    /*for the img inside your div */
    background-color: white;
  }

  h1 {
    color: white !important;
  }

  .one {
    color: white;
    background-color: #f5f5f5;
    background-image: -webkit-linear-gradient( 95deg,
    hsl(204, 86%, 53%) 18%,
    hsl(217, 71%, 53%) 18%);
    min-height: 400px;
  }

  .three {
    background-color: #f5f5f5;
    /*     background-image: -webkit-linear-gradient( 95deg,
    whitesmoke 55%,
    white 55%); */
    margin-top: 2rem;
    border-bottom: 1px solid rgba(10, 10, 10, 0.1);
    border-top: 1px solid rgba(10, 10, 10, 0.1);
    padding: 4rem;
  }

  .two {}
</style>


// WEBPACK FOOTER //
// src/components/Home.vue?39f828d8